import { Box, alpha } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  height: theme.typography.pxToRem(700),
  position: 'relative',
  '& .HSBGContainer': {
    height: '100%',
    width: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 0,
  },
  '& .HSBGGradient': {
    background:
      'linear-gradient(0deg, rgba(0, 0, 0, 0.00) 82.19%, rgba(0, 0, 0, 0.50) 94.37%), linear-gradient(180deg, rgba(0, 0, 0, 0.00)56.98%), radial-gradient(50% 50% at 50% 49.89%, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.7) 100%)',
    width: '100%',
    height: '100%',
    position: 'absolute',
    left: 0,
    top: 0,
    zIndex: 2,
  },

  '& .HSContentContainer': {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'end',
    alignItems: 'center',
    textAlign: 'center',
    margin: 'auto',
    maxWidth: theme.spacing(125),
    height: '100%',
    paddingBottom: theme.spacing(10),
    zIndex: 5,
    [theme.breakpoints.down('lg')]: {
      width: '100%',
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    [theme.breakpoints.down('md')]: {
      paddingBottom: theme.spacing(5),

    },
  },
  '& .HSBGPattern': {
    position: 'absolute',
    bottom: 0,
    width: '100%',
    height: theme.typography.pxToRem(205),
    zIndex: 1,
    // Smooth fade at the top, normal at the bottom
    maskImage: `linear-gradient(
        to bottom,
         ${alpha(theme.palette.common.black, 0.1)} 50%,
         ${alpha(theme.palette.common.black, 0.5)} 90%
      )`,
  },
  '& .HSSubTitle': {
    maxWidth: theme.spacing(75.75),
  },

}));

export default StyledBox;
